/* eslint-disable import/no-unresolved */
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  Stack,
  Button,
} from '@mui/material';
import { Dayjs } from 'dayjs';
import Select from '@/components/Forms/GroupSelect';
import DatePicker from '@/components/ReportFilter/utils/DatePicker';

const boxStyle = {
  position: 'absolute',
  height: 'fit-content',
  width: '500px',
  backgroundColor: '#fff',
  borderRadius: '15px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 4,
};

interface DatePickerProps {
  show: boolean;
  handleAction: () => void;
  handleModalClose: () => void;
  handleChangeFromDate: (value: Dayjs | null) => void;
  handleChangeToDate: (value: Dayjs | null) => void;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  selectedCompany: string;
  selectedcostCenter: string;
  costCenters: any;
  companies: any;
  handleChangeCostCenter: (selected: string) => void;
  handleChangeCompany: (selected: string) => void;
  filterType?: 'sales' | 'stock' | 'item';
}
const DatePickerModal: React.FC<DatePickerProps> = ({
  show,
  handleAction,
  handleModalClose,
  handleChangeFromDate,
  handleChangeToDate,
  fromDate,
  toDate,
  selectedCompany,
  selectedcostCenter,
  companies,
  costCenters,
  handleChangeCompany,
  handleChangeCostCenter,
  filterType = 'sales',
}) => (
  <div>
    <Modal
      open={show}
      onClose={() => handleModalClose()}
      aria-labelledby="logout-modal-title"
      aria-describedby="logout-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Slide direction="up" in={show} mountOnEnter unmountOnExit>
        <Box sx={boxStyle}>
          <Box
            sx={{
              width: '20%',
              mr: 'auto',
              position: 'absolute',
              top: '0',
              left: '0',
            }}
          >
            <Button
              type="button"
              onClick={handleModalClose}
              sx={{ borderRadius: '100px' }}
            >
              Close
            </Button>
          </Box>
          <Typography textAlign="left" fontWeight={600} mt={4}>
            Filter By Date
          </Typography>
          <Stack mt={1} spacing={2}>
            <Box sx={{ display: 'flex', gap: '6px' }}>
              <DatePicker
                label="From Date"
                handleChange={handleChangeFromDate}
                value={fromDate}
              />
              <DatePicker
                label="To Date"
                handleChange={handleChangeToDate}
                value={toDate}
              />
            </Box>

            {filterType === 'sales' && (
              <>
                <Stack spacing={1}>
                  <Typography textAlign="left" fontWeight={600}>
                    Company
                  </Typography>
                  <Select
                    name="company"
                    selected={selectedCompany}
                    label="Select Company"
                    handleSelected={handleChangeCompany}
                    items={companies}
                    size="medium"
                  />
                </Stack>
                <Stack spacing={1} mb={4}>
                  <Typography textAlign="left" fontWeight={600}>
                    Cost Center
                  </Typography>
                  <Select
                    name="cost center"
                    selected={selectedcostCenter}
                    label="Select Cost Center"
                    handleSelected={handleChangeCostCenter}
                    items={costCenters}
                    size="medium"
                  />
                </Stack>
              </>
            )}

            <Button
              type="button"
              variant="contained"
              onClick={handleAction}
              disableElevation
            >
              Continue
            </Button>
          </Stack>
        </Box>
      </Slide>
    </Modal>
  </div>
);

export default DatePickerModal;
